<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="text-center" style="padding: 50px 0">
          <img alt="IzOnay" :src="imgLogoPath()" />
        </div>

        <form @submit.prevent="login()">
          <fieldset :disabled="loading">
            <div class="mb-3">
              <div class="alert alert-info">
                <h4 class="alert-heading text-center">SMS ile Doğrulama</h4>
                <p v-if="loginData.Mobile">
                  <b>{{ loginData.Mobile }}</b> numaralı telefonunuza doğrulama
                  kodu SMS olarak gönderilmiştir ve kısa süre içerisinde
                  ulaşacaktır.
                </p>
                <p v-else>
                  Telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa
                  süre içerisinde ulaşacaktır.
                </p>
              </div>
            </div>

            <div class="mb-3">
              <label for="email" class="form-label"
                >Doğrulama kodunu giriniz:</label
              >
              <input
                type="text"
                v-model="loginData.OTP"
                class="form-control form-control-lg text-center"
                id="OTP"
                required
              />
            </div>

            <div class="d-grid gap-2">
              <input
                type="submit"
                class="btn btn-primary btn-lg"
                value="Devam Et"
              />
            </div>
          </fieldset>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div v-if="errorMessage" style="margin-top: 20px">
          <div class="alert alert-danger" v-text="errorMessage"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LoginWithMFA",
  props: {
    loginData: Object
  },
  created() {
    if (this.loginData == null) this.$router.push("/");
  },
  data: () => ({
    loading: false,
    errorMessage: null
  }),
  methods: {
    imgLogoPath() {
      try {
        return window.settings.customization.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
      } catch (e) {
        return require("../assets/logo.png");
      }
    },
    async loginWithMFA(accountCode, email, sessionId, OTP) {
      const { data } = await axios.post("/token/postMFA", {
        AccountCode: accountCode,
        Email: email,
        SessionId: sessionId,
        OTP: OTP,
        Source: "Mobile"
      });
      return data;
    },
    login() {
      console.log("Oluşturuldu:", this);
      this.loading = true;
      this.loginWithMFA(
        this.loginData.AccountCode,
        this.loginData.Email,
        this.loginData.SessionId,
        this.loginData.OTP
      )
        .then(x => {
          this.errorMessage = null;
          console.log("Gelen sonuç:", x);
          if (x.Success) {
            window.localStorage.setItem("user", JSON.stringify(x.Data));
            axios.defaults.headers.common["token"] = x.Data.Key;
            this.$root.$data.login = x.Data;
            this.registerDeviceToken();
            this.saveBaseUrl();
            this.$store.commit("setUser", x.Data.User);
            if(this.$route.query.redirect)
              this.$router.push(this.$route.query.redirect);
            else
              this.$router.push("/index");
            console.log(
              "Token geldi: ",
              axios.defaults.headers.common["token"]
            );
          } else {
            this.errorMessage = x.ErrorMessages;
            this.loginData.OTP = "";
            this.loading = false;
          }
          console.log("Token geldi: ", axios.defaults.headers.common["token"]);
        })
        .catch(e => {
          console.log("Error:", e);
          this.loginData.OTP = "";
          if (e.response === undefined) {
            this.errorMessage =
              "Erişim sağlanamadı. Lütfen internet bağlantınızı kontrol edin.";
          } else if (e.response.status == 400) {
            this.errorMessage =
              window.getModelStateString(e.response.data.ModelState) ||
              e.response.data.Message;
          } else {
            this.errorMessage =
              "Beklenmeyen bir hata oluştu. Lütfen bir süre sonra tekrar deneyin";
          }
          this.loading = false;
        });
    }
  }
};
</script>
